import { fetchApi } from '../api/digitalVault';
import { parseFiles, parseFolders, parsePagination } from '../utils';
// TODO :Should use method return type GetUserRepo instead of just using UserFolder.
// Should use type RawUserFolders instead of just using RawUserRepoFolderDefinition
// This needs to be refactored, design pending
const getUserRepoFolder = async (params, repository, logger) => {
    const userRepo = await fetchApi(params, `repository/${repository}/folder`, {}, false, logger);
    const { folder, file, name, deleted, parentPath, size, '@totalCount': total, versionCreated, link, } = userRepo.folder;
    const { hasNextPage, nextPageParams } = parsePagination(link);
    const parsedFolder = { ...parseFolders({ ...userRepo })[0] };
    return {
        name: name.$,
        size: size.$,
        data: [
            ...parseFolders({ folder: folder }),
            ...parseFiles({ file: file }),
        ],
        totalCount: total,
        deleted: deleted.$,
        favorite: parsedFolder?.favorite || false,
        parentPath: parentPath.$,
        hasNextPage,
        paginate: () => {
            return hasNextPage && getUserRepoFolder(nextPageParams, repository, logger);
        },
        versionCreated: versionCreated.$,
        originData: { ...parsedFolder, folder: [], file: [] }, // folder and file data is already present in data property above
    };
};
export default getUserRepoFolder;
